class SelectComponent extends HTMLElement {
  constructor() {
    super();
    this.initEvents();
  }

  initEvents() {
    const selectTrigger = this.querySelector('[role="trigger"]');
    const placeholder = this.querySelector('[role="placeholder"]');
    const selectDrop = this.querySelector('[role="select-drop"]');
    const selectItems = this.querySelectorAll('[role="select-item"]');

    if (!selectDrop) return;

    let hideTimer = null;
    const clearHide = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
    };
    const show = () => {
      clearHide();
      selectDrop.classList.remove('hidden');
      this.setAttribute('aria-expanded', 'true');
    };
    const hideImmediate = () => {
      clearHide();
      selectDrop.classList.add('hidden');
      this.setAttribute('aria-expanded', 'false');
    };
    const hide = (delay = 150) => {
      clearHide();
      hideTimer = setTimeout(() => {
        selectDrop.classList.add('hidden');
        this.setAttribute('aria-expanded', 'false');
        hideTimer = null;
      }, delay);
    };

    selectTrigger?.addEventListener('click', (e) => {
      e.stopPropagation();
      if (selectDrop.classList.contains('hidden')) {
        show();
      } else {
        hideImmediate();
      }
    });

    if (window.matchMedia('(min-width: 769px)').matches) {
      this.addEventListener('mouseenter', show);
      this.addEventListener('mouseleave', () => hide(120));

      selectDrop.addEventListener('mouseenter', show);
      selectDrop.addEventListener('mouseleave', () => hide(120));
    }

    selectItems?.forEach((item) => {
      item.addEventListener('click', (ev) => {
        ev.stopPropagation();
        this.dataset.changeValue === 'true' && (placeholder.innerHTML = item.innerHTML);
        hideImmediate();
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        hideImmediate();
      }
    });

    window.addEventListener('resize', () => {
      clearHide();
    });
  }
}

if (!customElements.get('select-component')) {
  customElements.define('select-component', SelectComponent);
}
